const Machines = () => import("Modules/configuration/machines/views/Machines");
const MachinesForm = () => import("Modules/configuration/machines/views/MachinesForm");

export default {
    children: [
        {
            path: "configuration/machines",
            name: "settings_machines",
            component: Machines,
            meta: {
                requiresAuth: true,
                title: "lang.machines",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["machines.read"],
            },
        },
        {
            path: "configuration/machine/:id?",
            name: "machine",
            component: MachinesForm,
            meta: {
                requiresAuth: true,
                title: "lang.machines",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["machines.read"],
            },
        },
    ],
};
